import React from 'react';
import { FormattedText, formatText } from 'core/i18n';
import Storage from 'utilities/storage';
import { PUBLICA_URL } from 'constants/index';
import MessagesScreen from 'components/messagesScreen/messagesScreen';

const AbortedView = () => {
    const messagesScreenAction = () => {
        Storage.cookies.remove('accessToken');
        Storage.cookies.remove('refreshToken');
        window.location.href = PUBLICA_URL;
    };
    return (
        <div className="main-container messages-main-container basic-layering">
            <MessagesScreen
                iconClass="icons icons--icon-warning"
                title={formatText('messagesScreen-defaultErrorTitle')}
                subtitle=""
                buttonText={formatText('button-understood')}
                buttonClass="form__button form__button-secondary"
                action={messagesScreenAction}
            >
                <FormattedText value="messagesScreen-defaultErrorContent" />
            </MessagesScreen>
        </div>
    );
};

export default AbortedView;
